import { FileQuestion } from 'lucide-react'
import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'

export function NotFound() {
  return (
    <div className="flex flex-1 items-center justify-center min-h-[60vh]">
      <div className="flex flex-col items-center gap-6" style={{ marginTop: '-10%' }}>
        <div className="rounded-2xl bg-gray-100 p-5">
          <FileQuestion className="size-10 text-gray-400" strokeWidth={1.5} />
        </div>
        <div className="text-center space-y-1">
          <p className="text-base font-medium text-neutral-800">Stran ne obstaja</p>
          <p className="text-sm text-neutral-400">Vsebina, ki jo iščete, ni na voljo.</p>
        </div>
        <Button asChild variant="outline" size="sm">
          <Link to="/">Nazaj na začetno stran</Link>
        </Button>
      </div>
    </div>
  )
}
